import styled from 'styled-components';

import { basicSmallTextStyle, StyledFlex } from '@dreryk/react-components';

export const StyledPatientAutosuggestItemDetails = styled(StyledFlex)`
   ${basicSmallTextStyle};
   color: ${(props) => props.theme.border};
`;

StyledPatientAutosuggestItemDetails.displayName = 'StyledPatientAutosuggestItemDetails';
